<div class="main global-table-wrapper">
    <!-- Header Section -->
    <div class="title-btn">
        <div class="main-title">
            <h1>Farms Information</h1>
            <p>Manage farms information and permissions</p>
        </div>
        <div class="new-placement">
            <button
                class="btn btn-action-primary"
                (click)="addNewFarm()"
                *appHasRole="['Admin']"
            >
                <i class="fas fa-plus"></i>
                New Farm
            </button>
        </div>
    </div>

    <!-- Farms Table -->
    <p-table
        [value]="filteredFarms"
        responsiveLayout="scroll"
        [loading]="loading"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Farm Name</th>
                <th>House</th>
                <th>Partitions</th>
                <th>Address</th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-farm>
            <tr>
                <td>{{ farm.name }}</td>
                <td>
                    {{
                        farm.farmHouses?.length !== undefined
                            ? farm.farmHouses.length
                            : 'N/A'
                    }}
                </td>
                <td *ngIf="getFarmPartitionsCount(farm) as partitionsCount">
                    {{
                        partitionsCount !== null &&
                        partitionsCount !== undefined
                            ? partitionsCount
                            : 'N/A'
                    }}
                </td>
                <td>
                    {{ farm.address || 'Address is not available' }}
                </td>
                <td>
                    <a
                        (click)="viewFarmDetails(farm)"
                        pTooltip="View Details"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-eye"></i
                    ></a>
                </td>
                <td>
                    <a
                        (click)="editFarm(farm)"
                        pTooltip="Edit Farm"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i
                            class="fas fa-edit"
                            *appHasRole="['Admin', 'Top Management']"
                        ></i
                    ></a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
